import { Skeleton } from '@mui/material';
import injectStores from '../RootStore/injectStores';
import { computed } from 'mobx';
import React from 'react';
import ViewStore from 'stores/ViewStore';

interface SkeletonCardBodyProps {
  viewStore?: ViewStore;
  height?: number;
  width?: number;
}

const SkeletonCardBody = injectStores(
  ({ viewStore, height, width }: SkeletonCardBodyProps) => {
    const { cardHeaderSize, cardBodySize, isMobile } = viewStore || {};

    const skeletonWidth = computed(() => {
      if (width) return width;
      if (!cardBodySize?.width || !cardHeaderSize?.width) return 0;
      return isMobile ? cardBodySize.width - 15 : cardBodySize.width;
    }).get();

    const skeletonHeight = computed(() => {
      if (height) return height;
      if (!cardBodySize?.height || !cardHeaderSize?.height) return 0;
      return cardBodySize.height + 16;
    }).get();

    return (
      <Skeleton
        animation="wave"
        variant="rounded"
        width={skeletonWidth}
        height={skeletonHeight}
      />
    );
  }
);

export default SkeletonCardBody;
